export const roleType = {
  lender: "L",
  broker: "V",
  borrower: "B",
  brokerAdmin: "V",
  lenderAdmin: "L",
  customerServicing: "C",
  admin: "A",
  loanLinQAdministrator: "B",
};

export const loadingTypes = {
  fulfilled: "fulfilled",
  idle: "idle",
  loading: "loading",
  error: "error",
  failed: "failed",
};

export const oracleConfig = {
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
  },
};

export const thirdPartyPayoffArr = [
  /* ================= STEP 1 ================= */
  {
    arr: [
      {
        field: "requestor_type"
      },
      {
        field: "requestor_name",
      },
      {
        field: "payoff_good_through_date",
      },
      {
        field: "demand_expiration_date",
      },
      // {
      //   field: "from_address",
      // },
      // {
      //   field: "lender_title",
      // },
      // {
      //   field: "lender_number",
      // },
    ],
  },

  /* ================= STEP 2 ================= */
  {
    arr: [
      {
        field: "property_street",
      },
      {
        field: "property_city",
      },
      {
        field: "property_state",
      },
      {
        field: "property_zip",
      },
      {
        field: "account_name",
      },
      {
        field: "account_number",
      },
      { field: "loan_property" },
    ],
  },
];